import { createSlice } from "@reduxjs/toolkit";
import { ERROR_MESSAGES } from "../../constants/error";

const initialState = {
  loading: false,
  loadingCount: 0,
  error: null,
};

const SILENT_ERRORS = [
  "USER_IN_IMPORTANT_TASK",
  "BUSINESS_NOT_FOUND",
  "BUSINESS_NOT_MATCHING",
  "USER_IN_IMPORTANT_TASK_POS",
  "Business not matching",
  "Business not found",
  "Refresh token is null",
  "Cannot connect to server, Please try again.",
  "Internal server error",
  "INVALID_REFRESH_TOKEN",
  "BILL_COMPLETED",
];

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;

      if (action.payload) {
        state.loadingCount = Math.max(1, state.loadingCount);
      } else {
        state.loadingCount = 0;
      }
    },

    startLoading: (state) => {
      state.loadingCount += 1;
      state.loading = true;
    },

    finishLoading: (state) => {      
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      state.loading = state.loadingCount > 0;
    },

    setError: (state, action) => {
      const errorMessage = ERROR_MESSAGES[action.payload] || action.payload;
      state.error = errorMessage;
      if (errorMessage && !SILENT_ERRORS.includes(action.payload)) {
        alert(errorMessage);
        state.error = null;
      }
    },
    clearError: (state) => {
      state.error = null;
    },

    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },

    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },

    openModal: (state, action) => {
      state.modal.isOpen = true;
      state.modal.type = action.payload.type;
      state.modal.data = action.payload.data || null;
    },

    closeModal: (state) => {
      state.modal.isOpen = false;
      state.modal.type = null;
      state.modal.data = null;
    },

    updateModalData: (state, action) => {
      state.modal.data = {
        ...state.modal.data,
        ...action.payload,
      };
    },
  },
});

export const {
  setLoading,
  startLoading,
  finishLoading,
  setError,
  clearError,
  setSuccessMessage,
  clearSuccessMessage,
  openModal,
  closeModal,
  updateModalData,
} = commonSlice.actions;

export const selectLoading = (state) => state.common.loading;
export const selectError = (state) => state.common.error;
export const selectSuccessMessage = (state) => state.common.successMessage;
export const selectModal = (state) => state.common.modal;

export default commonSlice.reducer;
